import ReactGA from "react-ga4";

const trackingId = "G-CPSC7Z0WT4"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);
ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Page" });

export default ReactGA;
